import { useEffect } from 'react'
import { toast as showToast } from 'sonner'
import { type Toast } from '#app/utils/toast.server.ts'

export function useToast(toast?: Toast | null) {
	useEffect(() => {
		let timer: string | number | NodeJS.Timeout | undefined
		if (toast) {
			timer = setTimeout(() => {
				showToast[toast.type](toast.title, {
					id: toast.id,
					description: toast.description,
				})
			}, 100)
		}

		return () => {
			if (timer) {
				clearTimeout(timer)
			}
		}
	}, [toast])
}
